// What is left of the village rules: the margin round the plan nothing is built in, and the shape
// of a claimed-land rectangle the renderer still draws.
export const PLACE_MARGIN = 2;
export interface ClaimRect { x0: number; y0: number; x1: number; y1: number }
